import React from 'react';
import { authRoles } from 'app/auth';

export const HeidiLmsConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	// Org admins only (NOT platform super-admins); the api re-checks org-admin +
	// LMS-enabled. SSO is org-scoped and the hub refuses privileged accounts.
	auth: authRoles.instructor,
	routes: [
		{
			path: '/heidi-lms',
			component: React.lazy(() => import('./HeidiLms'))
		}
	]
};
